import { type Mapper } from '@coris-ts/repository/mapper/mapper'
import {
  type CommunityPostsPageEntity,
  type CommunityChannelEntity,
  type CommunityTotalsEntity
} from '../../data/entities/community.entity'
import { type CommunityResponse, type ComparedValue } from '../models/community'
import { ComparedValueEntity } from '../../data/entities/events.entity'

export interface CombinedCommunityEntity {
  posts: CommunityPostsPageEntity
  channels: CommunityChannelEntity[]
  totals: CommunityTotalsEntity
}

export class CommunityEntityToCommunityResponseMapper implements Mapper<CombinedCommunityEntity, CommunityResponse> {
  public map(from: CombinedCommunityEntity): CommunityResponse {
    return {
      summary: {
        posts: this.mapComparedValue(from.totals.posts),
        views: this.mapComparedValue(from.totals.views),
        comments: this.mapComparedValue(from.totals.comments),
        upvotes: this.mapComparedValue(from.totals.upvotes)
      },
      timeSeries: from.totals.periods.map((item) => ({
        date: item.date,
        posts: item.posts,
        views: item.views,
        comments: item.comments,
        upvotes: item.upvotes
      })),
      channels: from.channels.map((item) => ({
        name: item.name,
        posts: this.mapComparedValue(item.posts),
        views: this.mapComparedValue(item.views),
        comments: this.mapComparedValue(item.comments),
        upvotes: this.mapComparedValue(item.upvotes)
      })),
      posts: from.posts.items.map((item) => ({
        title: item.title,
        createdBy: item.created_by,
        createdAt: item.created_at,
        views: this.mapComparedValue(item.views),
        comments: this.mapComparedValue(item.comments),
        upvotes: this.mapComparedValue(item.upvotes)
      })),
      totalPosts: from.posts.total
    }
  }

  private mapComparedValue(from: ComparedValueEntity): ComparedValue {
    return {
      current: from.current,
      previous: from.previous,
      diff: from.diff
    }
  }
}
